import _ from 'lodash';
import {constants, BASE_PATH, GDPR_COUNTRIES} from "../config";
import log from 'common/Logger';
import bridge from 'common/bridge';
import {getUser, getStudent, isLoggedIn} from 'common/UserService';
import {getUserSettings, isAdmin, isAdsDisabled, isImpersonate} from './UserService';
import { getProgressLevels } from 'common/api'
import moment from "moment/moment";
import {formatDateDashes} from "../pages/new/refactoring pages/shared/helpers/formatDate";

/**
 * Utilities Class
 */
class Utils {
  /**
   * Timers
   * @type {Object}
   */
  static timers = {};

  static currPlacementIdx = 100;
  static OLD_SAFARI_VERSION = 12;
  static OLD_EDGE_VERSION = 50;

  static progressLevels = localStorage.getItem('progressLevels') ? JSON.parse(localStorage.getItem('progressLevels')) : [];

  static {
    (async () => {
      if (!isLoggedIn() || localStorage.getItem('progressLevels')) return;
      Utils.progressLevels = await getProgressLevels();
      localStorage.setItem('progressLevels', JSON.stringify(Utils.progressLevels));
    })();
  }


  /**
   * Regular Expressions
   * @type {Object}
   */
  static regexes = {
    queryString: /[?&]+([^=&]+)=([^&]*)/gi,
    queryStringRt: /[?&]+rt_?([^=&]+)=([^&]*)/gi,
    // eslint-disable-next-line max-len
    isMobile: /(?!.*PC.*)(?:iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile)/i,
    // eslint-disable-next-line max-len
    isTablet: /(?:ipad|a1_07|a1-810|a1-811|a1-830|a3000-h|a3300-hv|a3500-f|a3500-fl|a3500-h|a3-a10|a5500-f|a5500-h|a7600-f|a7600-h|android 3|archos 101|archos 80g9|aries_785|arnova 101|at100|at10-a|at200|at300|b1-710|b1-711|b1-730|b1-770|b1-780|b1-810|b1-830|b1-850|b1-a71|b6000-f|b6000-h|b8000-f|b8000-h|b8080-f|b8080-h|bn nookhd+|bnrv200|bntv250|bntv250a|bntv400|bntv450|bntv600|breeze 10|cm_tenderloin|dell streak 7|dl1010q|e2281|e-tab ivory|gt-n5100|gt-n5110|gt-n8000|gt-n8010|gt-n8013|gt-n8020|gt-p1000|gt-p1010|gt-p3100|gt-p3110|gt-p3113|gt-p5100|gt-p5110|gt-p5113|gt-p5200|gt-p5210|gt-p5220|gt-p7300|gt-p7310|gt-p7500|gt-p7510|hpwos|hudl 2|ideapad|ideatab|k00e|k00f|k010|k011|k012|k017|k01a|kfapwa |kfapwi|kfarwi|kfaswi|kfauwi|kfdowi|kffowi|kfgiwi|kfjwa|kfjwi|kfmewi|kfot|kfsawa|kfsawi|kfsowi|kfsuwi|kftbwi|kfthwa|kfthwi|kftt|kindle|lguk410|lguk750|lguk932|lg-v400|lg-v410|lg-v490|lg-v495|lg-v496|lg-v497|lg-v500|lg-v520|lg-v521|lg-v522|lg-v700|lg-v930|lifetab|m532|me172v|me173x|me301t|me302c|me302kl|me371mg|mediapad|memo pad|micromax_a101|mz601|mz604|nexus 10|nexus 7|nx008hd8g|nx16a10132s|nx16a11264|nx16a8116k|nx700qc|nx785qc8g|nxa116qc164|nxa8qc116|onda v989|p310a|p310x|p320x|padfone|playbook|pmp5580c|pmp7280c3g|pmt3377_wi|pmt7077_3g|qmv7a|qmv7b|qtair7|qtaqz3|qv830|rct6103w46|rct6203w46|rct6213w87dk|rct6213w87m|rct6303w87dk|rct6303w87m|rct6513w87|rct6573w23|rct6603w47m7|rct6603w87m7|rct6703w13|rct6773w22|rct6773w42b|rct6873w42m|rct6973w43|rct6k03w13|s5000-f|s5000-h|s6000l-f|s920_row|sch-i705|sch-i800|sch-i915|sch-i925|sgh-i467|sgh-i497|sgh-i777|sgp311|sgp312|sgp321|sgp511|sgp512|sgp521|sgp561|sgp611|sgp612|sgp621|sgp712|sgp771|sgpt12|sgpt13|shv-e210k|slider sl101|smart tab|sm-p550|sm-p600|sm-p605|sm-p900|sm-p905|sm-t\d\d\d|tab 2 a10-70f|tab 2 a7-30hc|tab 2 a8-50f|tab 2 a8-50lc|tab s8-50f|tab2a7-10f|tab2a7-20f|tablet|tb2-x30f|tb3-710f|tb3-710i|tb3-850f|tb3-850m|tb3-x70f|tb-8504f|tb-8704f|tb-x103f|tb-x304f|tc802a|tf300t|tf700t|touchpad|tf201|tf101|venue 7 3730|venue 7 hspa+|venue 8 3830|venue 8 7840|venue 8 hspa+|vk810 4g|vk815|vodafone smart ii|xolo a700|xoom|yb1-x90f|yoga b6000-f|yoga b8000-f|yt3-850f|yt3-x50f|yt3-x90f|yt-x703f|zaffire 1010)/i,
  };

  /**
   * Resources Map
   * @type {Map<string, Promise>}
   */
  static resourcesMap = new Map(null);

  /**
   * Take Time for a Performance Measurements Point
   *
   * @param {String} name - point name
   * @param {number} [value] - point value
   */
  static takeTime(name, value) {
    value = value || performance.now();
    this.timers[name] = value;
  }

  /**
   * Converts a UTC date to a local date by user.timezone
   * @param date
   * @returns {*}
   */
  static fromUTCToLocal(date) {
    return date
  }

  /**
   * Converts a user.timezone date to a UTC date
   * @param date
   * @returns {*}
   */
  static fromLocalToUTC(date) {
    return date
  }

  static getTimeZoneFromBrowser() {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (e) {
      return null
    }
  }


  /**
   * Get Time Difference from Timer
   *
   * @param {String} name
   * @return {number}
   */
  static getTime(name) {
    const timer = this.timers[name];
    return timer ? Math.round(performance.now() - timer) : 0;
  }

  /**
   * Clear Time
   *
   * @param {String} name
   */
  static clearTime(name) {
    delete this.timers[name];
  }

  /**
   * Get Duration from Page Start
   *
   * @return {number} - ms
   */
  static getPageSecond() {
    const now = _.result(window, 'performance.now', null);
    return now ? Math.round(now) : null;
  }

  static getQueryStringParam(name) {
    const params = Utils.getQueryStringParams();
    return _.isEmpty(params) ? null : params[name]
  }

  /**
   * Get Query String Parameters
   *
   * @param {String} url - an URL to extract the key value pairs from
   * @param {boolean} [rtOnly=false] - when true, returns only the key value pairs with the 'rt_' prefix
   *
   * @return {Object} - an object with key value pairs
   */
  static getQueryStringParams = _.memoize(
      function(url = window.location.href, rtOnly = false) {
        const params = {}; // params is a reference to the object
        if (typeof url !== 'string') {
          return params;
        }
        url.replace(
            rtOnly ? this.regexes.queryStringRt : this.regexes.queryString,
            (m, key, value) => {
              params[key] = value;
            },
        );
        return params;
      },
      function(url, rtOnly = false) {
        return `${rtOnly ? 1 : 0}_${url}`;
      },
  );

  /**
   * Takes a Query String Parameters
   *
   * @param {String} url - an URL to extract the key value pairs from
   * @param {boolean} [rtOnly=false] - when true, returns only the key value pairs with the 'rt_' prefix
   *
   * @return {Object} - an object with key value pairs
   */
  static paramsToQueryString = function(params) {
    return _.join(_.map(params, (val, key) => {
      return `${key}=${val}`;
    }), '&');
  };

  /**
   * Convert Milliseconds to Seconds
   *
   * @param {number} ms
   *
   * @return {number} - seconds representation with 2 digits after the decimal point
   */
  static ms2s(ms) {
    return Number(Number(ms / 1000).toFixed(2));
  }

  /**
   * Convert Seconds to Milliseconds
   *
   * @see Math.round()
   *
   * @param {number} seconds
   *
   * @return {number} - milliseconds representation rounded according to Math.round()
   */
  static s2ms(seconds) {
    return Math.round(seconds * 1000);
  }

  /**
   * Creates an Element from compiled lodash template
   *
   * @param {Function} compiledTemplate - compiled lodash template
   * @param {Object} [data]
   *
   * @return {Element | null} - the interpolated template,
   *                            otherwise null.
   */
  static createElementFromTemplate(compiledTemplate, data = {}) {
    const tempDiv = window.document.createElement('div');
    tempDiv.innerHTML = compiledTemplate(data);
    return tempDiv.firstElementChild;
  }

  /**
   * Load Script
   *
   * Create a script tag and append it to the `<head>`,
   * if there is no `<head>` insert the tag before the first script tag on page.
   *
   * @see https://html.spec.whatwg.org/multipage/syntax.html#syntax-tag-omission
   *
   * @param {String} src
   *
   * @return {Promise} - resolve when the script is loaded,
   *                     reject on error
   */
  static loadScript(src, async = true, dataset = {}, attribs = {}) {
    return new Promise((resolve, reject) => {
      let js = document.createElement('script');
      js.src = src;
      _.forEach(dataset, (val, key) => {
        js.dataset[key] = val;
      })
      _.forEach(attribs, (val, key) => {
        js.setAttribute[key] = val;
      })
      js.onreadystatechange = function() {
        if (this.readyState === 'complete') {
          resolve();
        }
      }
      js.onload = function() {
        resolve();
      };
      js.onerror = function() {
        log.error('could not load script - '+src);
        reject();
      };
      if (async) {
        js.setAttribute('async', true);
      }
      document.head.appendChild(js);
    })
  }

  /**
   * Load Style
   *
   * Create a link tag and append it to the `<head>`,
   * if there is no `<head>` create a `<style>` tag and insert the content inside
   *
   * @see https://html.spec.whatwg.org/multipage/syntax.html#syntax-tag-omission
   *
   * @param {String} styleSource
   *
   * @return {Promise} - resolves after the style is loaded
   */
  static loadStyle(styleSource) {
    const head = window.document.getElementsByTagName('head')[0];
    if (head) {
      // <head> exists
      return new Promise((resolve, reject) => {
        // create link tag
        const link = window.document.createElement('link');
        link.type = 'text/css';
        link.rel = 'styleSheet';
        link.href = styleSource;
        link.onload = resolve;
        link.onerror = () => {
          reject(new Error(`failed to load link "${styleSource}"`));
        };
        // insert link tag
        try {
          head.appendChild(link);
        } catch (error) {
          reject(new Error(`failed to insert link "${styleSource}"`));
        }
      });
    } else {
      // <head> does not exist
      // @internal fetch returns a Promise
      return fetch(styleSource).
          then((response) => response.text()).
          then((text) => {
            try {
              // create style tag
              const s = window.document.createElement('style');
              s.textContent = text;
              // insert style tag
              this.insertBefore(s, window.document.getElementsByTagName('script')[0]);
            } catch (error) {
              return Promise.reject(new Error(`failed to insert style "${styleSource}"`));
            }
          }).
          catch((fetchError) => {
            return Promise.reject(new Error(`failed to load style "${styleSource}"`));
          });
    }
  }

  /**
   * Insert a Node before another Node
   *
   * @param {Node} nodeToInsert
   * @param {Node} node
   *
   * @throws {Error}
   */
  static insertBefore(nodeToInsert, node) {
    if (nodeToInsert.parentNode) {
      node.parentNode.insertBefore(nodeToInsert, node);
    }
  }

  /**
   * Create Template Function from String using eval()
   *
   * @see eval()
   *
   * @param {String} functionString
   *
   * @return {Function}
   */
  static createTemplateFunctionFromString(functionString) {
    // generate a unique function name
    const functionName = _.uniqueId('RtTemplateFn_');
    // run the function with eval()
    eval(`window['${functionName}'] = ${functionString}`);
    // return the reference to the function
    return window[functionName];
  }

  /**
   * Get page height (in pixels)
   *
   * @param {Window} windowElement
   *
   * @return {number}
   */
  static getPageHeight(windowElement = window) {
    if (!windowElement) {
      return 0;
    }
    const documentBody = windowElement.document.body;
    const documentElement = windowElement.document.documentElement;
    return Math.max(
        documentBody.scrollHeight, documentElement.scrollHeight,
        documentBody.offsetHeight, documentElement.offsetHeight,
        documentBody.clientHeight, documentElement.clientHeight,
    );
  }

  /**
   * Is Element Displayed
   *
   * @param {Element} element
   *
   * @return {boolean}
   */
  static isElementDisplayed(element) {
    return !!(element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length));
  }

  /**
   * Is Safari
   *
   * @return {boolean}
   */
  static isSafari = _.memoize(function() {
    return navigator.vendor.includes('Apple');
  });

  /**
   * Top Offset
   *
   * Calculates element's absolute offset from the top of the page.

   * @param {Element} element
   *
   * @return {number} - pixels from the top
   */
  static topOffset(element) {
    let top = 0;
    do {
      let transformTopOffset = 0;
      if (window.getComputedStyle && window.WebKitCSSMatrix) {
        const transformValue = getComputedStyle(element).transform || getComputedStyle(element).webkitTransform;
        const transformMatrix = new window.WebKitCSSMatrix(transformValue);
        transformTopOffset = transformMatrix.m42;
      }
      top += element.offsetTop + transformTopOffset || 0;
      element = element.offsetParent;
    } while (element);

    return top;
  }


    /**
     * appends all the query params from the current url to any given a.href link on the page.
     * if link already has an existing identical query param, then it takes precedence.
     *
     * e.g. if current url is:
     *  https://www.readtheory.org/about?a=1&b=2&c=3
     *  and there is a link on the page with href='https://www.readtheory.org/privacy?c=5&d=6 or href='/privacy?c=5&d=6'
     *  then running this function will change the a link to href='/privacy?a=1&b=2&c=5&d=6'
     */
  static addQueryParamsToLinks() {
    const linkEls = document.querySelectorAll('a');
    const currParams = this.getQueryStringParams(window.location.href);
    _.forEach(linkEls, currLinkEl => {
      if (currLinkEl.href.startsWith('/') ||
          currLinkEl.href.startsWith(location.hostname)) {
          const linkParams = Utils.getQueryStringParams(currLinkEl.href);
          _.assign(currParams, linkParams);
          let baseUri = _.split(currLinkEl.href, '?')[0];
          currLinkEl.href =  baseUri+'?'+this.paramsToQueryString(currParams);
      }
    });
  }




  static injectStyle(styleStr) {
    const styleEl = document.createElement('style');
    styleEl.innerHTML = styleStr;
    document.head.appendChild(styleEl);
  }

  static removeQueryStringParam(key) {
    const params = this.getQueryStringParams()
    delete params[key];
    history.replaceState(null,null, _.head(window.location.href.split('?'))+'?'+this.paramsToQueryString(params));
  }

  static extractParamsFromUrl(url) {
    let str = url.split('?')[1];
    if (str) {
      str = str.split('#')[0];
    }
    if (typeof str === 'undefined') str='';
    let paramsMap = {};
    let str_dec = decodeURIComponent(str);
    str_dec.replace(
      new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
      function ($0, $1, $2, $3) {
        $3 = $3 || null;
        paramsMap[$1] = $3;
      });
    return paramsMap;
  }

  static getUrlParams() {
    return Utils.extractParamsFromUrl(window.location.href);
  }

  static getUTM() {
    const urlParams = Utils.getUrlParams();
    return {
      source: urlParams['utm_source'],
      medium: urlParams['utm_medium'],
      campaign: urlParams['utm_campaign'],
    };
  }

  static isMobile() {
    const isMobile = /iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test(navigator.userAgent.toLowerCase()) && navigator.userAgent.search('PC') === -1;
    return isMobile;
  };

  static isMobileByWidth() {
    return Utils.getWindowWidth() < 768;
  }

  static isTablet() {
    const isTablet = /ipad|nexus 7|nexus 9|android 3.0|kindle|silk|kftt|kfot|kfjwa|kfjwi|kfsowi|kfthwa|kfthwi|kfapwa|kfapwi/i.test(navigator.userAgent.toLowerCase());
    return isTablet && navigator.userAgent.search('PC') === -1;
  };

  static isDesktop() {
    return !Utils.isMobile() && !Utils.isTablet();
  };

  static isGDPR(countryKey) {
    const matchedCountry = GDPR_COUNTRIES.find(country => _.isEqual(country.name.toLowerCase(), countryKey.toLowerCase()) || _.isEqual(country.code.toLowerCase(), countryKey.toLowerCase()));
    log.debug('isGDPR: ' + (matchedCountry ? 'YES' : 'NO'));
    return matchedCountry ? true : false;
  };

  static createPlacementEl(placementName, extraStyle = {}, extraData = {}) {
    const el = document.createElement('div');
    el.classList.add('pomad-placement');
    el.dataset.pmdPlacementIdx = Utils.currPlacementIdx;
    el.dataset.pmdPlacementName = placementName;
    Object.assign(el.dataset, extraData);
    Object.assign(el.style, extraStyle);
    el.style.textAlign = 'center';
    el.id = 'pmd-placement-' + placementName + '-' + Utils.currPlacementIdx;
    Utils.currPlacementIdx++;
    return el;
  }

  static isIntersectionObserverSupported() {
    return ('IntersectionObserver' in window &&
      'IntersectionObserverEntry' in window);
  }

  static getWindowWidth() {
    return window.top.screen.width || window.top.innerWidth && window.top.document.documentElement.clientWidth ? Math.min(window.top.innerWidth, window.top.document.documentElement.clientWidth) : window.top.innerWidth || window.top.document.documentElement.clientWidth || window.top.document.getElementsByTagName('body')[0].clientWidth;
  }

  static getWindowHeight() {
    return window.top.screen.height || window.top.innerHeight && window.top.document.documentElement.clientHeight ? Math.min(window.top.innerHeight, window.top.document.documentElement.clientHeight) : window.top.innerHeight || window.top.document.documentElement.clientHeight || window.top.document.getElementsByTagName('body')[0].clientHeight;
  }

  static setCookie(name, value, exdays = 1) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = `${name}=${value}; Path=/; Expires=${expires}`;
  }

  static deleteCookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  static clearCookies() {
    Utils.deleteCookie('rt_abt')
    //Utils.deleteCookie('JSESSIONID') you can't delete HTTP Only Cookies
  }

  static getWidth(el) {
    return parseFloat(window.getComputedStyle(el, null).width.replace("px", ""));
  }

  static getHeight(el) {
    return parseFloat(window.getComputedStyle(el, null).height.replace("px", ""))
  }

  static getBirthdateFromAge(age) {
    if (!age) return '';
    const today = new Date();
    const month = (today.getMonth() + 1).toString();
    const date = today.getDate().toString();
    return `${today.getFullYear() - age}-${month.length === 1 ? `0${month}` : month}-${date.length === 1 ? `0${date}` : date}`;
  }

  static getAgeFromBirthdate(dob) {
    if (!dob) return 0;

    const dobSplits = dob.split('-');
    if (dobSplits.length < 3) return 0;

    const today = new Date();
    const age = today.getFullYear() - parseInt(dobSplits[0]);
    return age;
  }

  static convertDateFormat(date) {
	if (!date) return null;
	const day = ('0' + (date.getDate())).slice(-2);
	const month = ('0' + (date.getMonth() + 1)).slice(-2);
	const year = date.getFullYear();
	return `${month}-${day}-${year}`;
  }

  static getDefaultFormatDate(strDate) {
	if (!strDate) return null;
	const date = new Date(strDate);
	const day = ('0' + (date.getDate())).slice(-2);
	const month = ('0' + (date.getMonth() + 1)).slice(-2);
	const year = date.getFullYear();
	return `${month}/${day}/${year}`;
  }

  static ordinal_suffix_of(i) {
    const j = i % 10,
        k = i % 100;
    if (j == 1 && k != 11) {
	  return i + "st";
    }
    if (j == 2 && k != 12) {
      return i + "nd";
    }
    if (j == 3 && k != 13) {
      return i + "rd";
    }
    return i + "th";
  }


  static getFullname(user) {
	let fullname = '';

	if (user.firstName) {
		fullname = _.capitalize(user.firstName);
	}
	if (user.lastName) {
		if (user.firstName) {
			fullname += ' ' + _.capitalize(user.lastName);
		} else {
			fullname = _.capitalize(user.lastName);
		}
	}

	return fullname;
  }

  static getDisplayName(user) {
	const firstName = user.firstName;
	const lastName = user.lastName;
	if(firstName && lastName) {
      return `${_.capitalize(lastName)}, ${_.capitalize(firstName)}`;
    } else if(!firstName && lastName) {
      return _.capitalize(lastName);
    } else if(firstName && !lastName) {
      return _.capitalize(firstName);
    } else {
      return user.username;
    }
  }

  static getCurrentUserDisplayName() {
    return this.getDisplayName(getUser());
  }

  static getUserSetting(user, settingKey) {
    if (user && user.userSettings && user.userSettings.length > 0) {
      const userSettings = JSON.parse(user.userSettings);
      if (userSettings[settingKey] !== undefined) {
        return userSettings[settingKey];
      }
	}
	return false;
  }

  static isNewClassUIVisible() {
  	return this.getUserSetting(getUser(), 'new_class_ui');
  }

  static isNewReportUIVisible() {
  	return this.getUserSetting(getUser(), 'new_report_ui');
  }

  static isActivityFeatureEnabled() {
	return this.getUserSetting(getUser(), 'feature_activities');
  }

  static isOldBrowser() {
	let isOld = false;
	let verOffset, browserName, ix, fullVersion = null;
	const userAgent = window.navigator.userAgent;
	const is_ie = /MSIE|Trident/.test(userAgent);
	if (is_ie) {
		isOld = true;
	} else if ((verOffset= userAgent.indexOf("Chrome")) != -1) {
		browserName = "Chrome";
		fullVersion = userAgent.substring(verOffset + 7);
	} else if ((verOffset = userAgent.indexOf("Safari")) != -1) {
		browserName = "Safari";
		fullVersion = userAgent.substring(verOffset + 7);
		if ((verOffset = userAgent.indexOf("Version")) != -1)
		  fullVersion = userAgent.substring(verOffset + 8);
	} else if ((verOffset = userAgent.indexOf("Edge")) != -1) {
		browserName = "Edge";
		fullVersion = userAgent.substring(verOffset + 5);
	}

	if (fullVersion) {
		if ((ix = fullVersion.indexOf(";")) !=-1 )
			fullVersion = fullVersion.substring(0, ix);
		if ((ix = fullVersion.indexOf(" ")) != -1)
			fullVersion = fullVersion.substring(0, ix);
		let browserVersion = parseInt('' + fullVersion, 10);
		if (isNaN(browserVersion)) {
			browserVersion = parseInt(navigator.appVersion,10);
		}
		if (browserName === 'Safari' && browserVersion <  Utils.OLD_SAFARI_VERSION) {
			isOld = true;
		}
		if (browserName === 'Edge' && browserVersion <  Utils.OLD_EDGE_VERSION) {
			isOld = true;
		}
	}

	return isOld;
  }

  static isAdsDisabled() {
    try {
      if (isAdsDisabled) return true;
      if (isAdmin() && !isImpersonate()) return true;
      const user = getUser()
      if (user && Utils.getUserSetting(user, 'ads_disabled')) return true;
      if (user && user.student) {
        let classesSettings = _.filter(
          _.result(user, 'student.classes', []),
          (value, key) => key.endsWith('-setting')) ;
        const hasAdsDisabled =
          _.filter(classesSettings, settings => settings['ads_disabled'])
        return !_.isEmpty(hasAdsDisabled);
      } else {
        return true
      }
    }
    catch(e) {
      log.error('isAdsDisabled() exception - ', e)
      return false;
    }
  }

  static setClassDetailInfo(sourceClass, targetClass) {
	targetClass.classSetting = sourceClass.classSetting;
	targetClass.classSettingObject = sourceClass.classSettingObject;
	targetClass.belowThirteen = sourceClass.belowThirteen;
  }

  static getClassSetting(user, settingKey) {
	let newQuizSettingsCount = 0;
	let hasSettingInItem = true;
	let classes = null;
	let classIds = [];
	if (!user) return false;
	if (user.teacher) {
		if (settingKey === 'new_quiz_ui' && bridge.page_data.isNewQuizEnabledForUser !== undefined) {
			return bridge.page_data.isNewQuizEnabledForUser;
		}
		classes = user.teacher.classes;
	}
	if (user.student) {
		classes = user.student.classes;
	}
	if (!classes) return false;
	if (classes.length === undefined) {
		classIds = _.keys(classes).filter(classId => !classId.includes('-setting'));
		hasSettingInItem = false;
	}
	if (classIds.length > 0) {
	  for (const classId of classIds) {
		let classSetting = {};
		if (hasSettingInItem) {
			classSetting = classId.classSettingObject;
		} else {
			classSetting = classes[`${classId}-setting`];
		}
		if (classSetting) {
			if (classSetting[settingKey]) newQuizSettingsCount++;
		}
	  }
	}
	return newQuizSettingsCount > 0 && newQuizSettingsCount === classIds.length;
  }

  static getCurrentLevel() {
	const student = getStudent();
	const progressLevels = Utils.progressLevels
	if (student & progressLevels.length > 0) {
		const totalPoints = student.totalPoints;
		const currentLevelItem = progressLevels.find(levelItem => levelItem.minPoints <= totalPoints && totalPoints <= levelItem.maxPoints);
		return currentLevelItem;
	} else {
		return null;
	}
  }

  static getCurrentLevelId() {
	const currentLevel = this.getCurrentLevel();
	return currentLevel ? currentLevel.progressLevelId : 1;
  }

  static getCurrentLevelForStudent(student) {
	const progressLevels = Utils.progressLevels;
	let currentLevel = null;
	if (student && progressLevels.length > 0) {
		const totalPoints = student.totalPoints;
		currentLevel = progressLevels.find(levelItem => levelItem.minPoints <= totalPoints && totalPoints <= levelItem.maxPoints);
	}
	return currentLevel;
  }

  static getCurrentLevelIdForStudent(student) {
	const currentLevelForStudent = this.getCurrentLevelForStudent(student);
	return currentLevelForStudent ? currentLevelForStudent.progressLevelId : 1;
  }

  static getLevelIconForStudent(student) {
	const currentLevel = this.getCurrentLevelForStudent(student);
	if (currentLevel) {
	  return `/assets/app/quiz/level/icon-level-${currentLevel.progressLevelId}.svg`;
	} else {
	  return `/assets/app/quiz/level/icon-question-level.svg`;
	}
  }

  static getLevelTitleForStudent(student) {
	const currentLevelItem = this.getCurrentLevelForStudent(student);
	return currentLevelItem ? currentLevelItem.title : 'New Level';
  }

  static getNextLevelForStudent() {
    const student = getStudent();
    const progressLevels = Utils.progressLevels;
    return progressLevels.find(levelItem => levelItem.minPoints > student.totalPoints);
  }

  static getNextLevelIconSrc() {
	const nextLevel = this.getNextLevelForStudent();
	let iconSrc = '/assets/app/quiz/icon-header-logo.svg';
	if (nextLevel) {
		iconSrc = `/assets${nextLevel.imageSource}`;
	}
	return BASE_PATH + iconSrc;
  }

  static getQuestionLevel(question) {
	return constants.studentLevels.findIndex(level => level === question.level) + 1;
  }

  static getLevelNumberFrom(strLevel) {
	return constants.studentLevels.findIndex(level => level === strLevel) + 1;
  }

  static getRubricTitleFor(question) {
	const questionType = question.questionType;
	const questionLevel = this.getQuestionLevel(question);
	return `Grade ${questionLevel} ${questionType} Writing Rubric`;
  }

  static handleLoadEmbedIframe(embedContainer) {
	const containerSelector = `.${embedContainer}`;
	const iframe = document.querySelector(`${containerSelector} iframe`);
	if (iframe) {
	  iframe.onload = function(){
		if (document.querySelector(containerSelector)) {
		  document.querySelector(containerSelector).style = "background: #fff";
		}
	  };
	}
  }

  static getRef() {
    return getUser() ? _.result(getUserSettings(), 'ref', null) : this.getRefFromEnv();
  }

  static getRefFromEnv() {
    let ref = Utils.getUrlParams()['ref']
    if (ref) return ref;
    ref = localStorage.getItem('ref');
    if (ref) return ref;
  }


  static getTokenFromEnv() {
    let ref = Utils.getUrlParams()['token']
    if (ref) return ref;
  }

  static getABTestParam() {
    return Utils.getUrlParams()['rt-ab'];
  }

  static getReportDateRanges() {
    const aug15 = moment().month(7).date(15);
    return {
      "Today": [moment().startOf("day").toDate(), moment().endOf("day").toDate()],
      "Yesterday": [moment().subtract(1, "days").startOf("day").toDate(),
        moment().subtract(1, "days").endOf("day").toDate()],
      "Last 7 Days": [moment().subtract(8, "days").startOf("day").toDate(),
        moment().subtract(1, "days").endOf("day").toDate()],
      "Last 2 Weeks": [moment().subtract(15, "days").startOf("day").toDate(),
        moment().subtract(1, "days").endOf("day").toDate()],
      "Last 30 Days": [moment().subtract(31, "days").startOf("day").toDate(),
        moment().subtract(1, "days").endOf("day").toDate()],
      "Last Month": [
        moment().subtract(1, "month").startOf("month").toDate(),
        moment().subtract(1, "month").endOf("month").toDate(),
      ],
      "This School Year": [
        moment().isBefore(aug15, 'day') ?
          aug15.subtract(1, "year").startOf("day").toDate() :
          aug15.startOf("day").toDate(),
        moment().subtract(1, "days").endOf("day").toDate()
      ],
      "Show All Data": [moment("2000-01-01").toDate(), moment().toDate()], // Unbounded range
    }
  }

  static getRelativeDate(daysOffset) {
    const date = new Date();
    date.setDate(date.getDate() + daysOffset);
    return formatDateDashes(date);
  }

  static getDaysBetween(date1, date2) {
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    const diffTime = Math.abs(d2 - d1);

    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  static downloadPDF(base64String, fileName, newTab=false) {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    if (newTab) {
      window.open(url, '_blank');
    } else {
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName || 'download.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }
}

window.clearCookies = Utils.clearCookies
export default Utils;
